import { Injectable } from '@angular/core';
import { Http, Response , Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { Router} from '@angular/router';

import * as firebase from 'firebase';

@Injectable()
    export class AuthService {

        constructor(private http: Http,private router: Router) { }

success: string;
login_name: string;
 getLoginData(username: string, password: string)
    {
        console.log(username);
      console.log(password);
     this.login_name=username;
 
    const headers=new Headers({'Content-Type': 'application/json'});
     return this.http.get('http://gunadhyasoft.com/girswebservices/getlogindetail.php?username='+username+'&pwd='+password+'')
     .map(
    (response: Response)=>
      {
      console.log("what do i get here "+response.json());
       this.success=response.json();
    if(response.json() == "Success")
    {
      console.log("In success");
    //alert("login successful");
 sessionStorage.setItem('user_name', this.login_name);
        this.router.navigate(['interviewdetail']);
    
   var test = sessionStorage.getItem("user_name"); //Let's grab it and save it to a variable
   console.log(test); //Logs "Hello World!

        return true;
    }
         alert('Please enter valid UserName and Password');
        return false;

    }
    )
    

    }
  
   

   checkCredentials(){
console.log("in checkCredentials");
  var test2 = sessionStorage.getItem("user_name");
 console.log(test2);
    if (sessionStorage.getItem('user_name') == null)
       {
      console.log("in checkCredentials");
        this.router.navigate(['login']);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/auth/login/auth.service.ts